import { render, staticRenderFns } from "./TemplateDashboard.vue?vue&type=template&id=29cd4812"
import script from "./TemplateDashboard.vue?vue&type=script&lang=js"
export * from "./TemplateDashboard.vue?vue&type=script&lang=js"
import style0 from "./TemplateDashboard.vue?vue&type=style&index=0&id=29cd4812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports